import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { AuthLayout } from "@/components/Brand";
import { Field, FormError, SubmitButton } from "@/components/common";
import { api, errMsg } from "@/lib/api";
import { t } from "@/i18n";

export function SimulatedEmailNote({ simulated }) {
  return (
    <p data-testid="email-delivery-note" className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs text-amber-900">
      {simulated ? t("email.simulatedNote") : t("email.noProviderNote")}
    </p>
  );
}

export function ForgotForm({ loginHref = "/login" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="space-y-4" data-testid="forgot-confirmation">
        <div className="flex items-start gap-3 rounded-xl border border-teal-200 bg-teal-50 p-4 text-sm text-teal-900">
          <MailCheck className="mt-0.5 h-5 w-5 shrink-0" />
          <p>{t("auth.forgotDone", { email })}</p>
        </div>
        <SimulatedEmailNote simulated={done.simulated} />
        <Link to={loginHref} className="text-sm font-medium text-teal-700" data-testid="back-to-login-link">{t("auth.backToLogin")}</Link>
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
      <FormError message={error} />
      <Field label={t("auth.email")} htmlFor="forgot-email">
        <Input id="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" data-testid="forgot-email-input" />
      </Field>
      <SubmitButton busy={busy} className="h-11 w-full" data-testid="forgot-submit-button">{t("auth.forgotButton")}</SubmitButton>
      <Link to={loginHref} className="block text-center text-sm font-medium text-teal-700" data-testid="back-to-login-link">{t("auth.backToLogin")}</Link>
    </form>
  );
}

export default function ForgotPassword() {
  return (
    <AuthLayout title={t("auth.forgotTitle")} subtitle={t("auth.forgotSubtitle")}>
      <ForgotForm />
    </AuthLayout>
  );
}
